export default __webpack_public_path__ + "static/media/luniu-download.f7e6df0a.gif";